import React, { useState } from 'react';
import {
  buildSharePayload,
  buildLineShareUrl,
  buildFacebookShareUrl,
  buildWhatsAppShareUrl,
  recordShare,
  getShareStats,
} from 'viral/viralShare';

export default function ViralShareCard({ keyword, mode = 'dream', variant = 'result' }) {
  const [copied, setCopied] = useState(false);
  const shareStats = getShareStats();

  if (variant === 'result' && !keyword?.trim()) return null;

  const { url, text } = buildSharePayload(keyword, mode, 'native');
  const lineUrl = buildLineShareUrl(text, buildSharePayload(keyword, mode, 'line').url);
  const facebookUrl = buildFacebookShareUrl(buildSharePayload(keyword, mode, 'facebook').url);
  const whatsappUrl = buildWhatsAppShareUrl(text, buildSharePayload(keyword, mode, 'whatsapp').url);

  const hook =
    variant === 'result'
      ? mode === 'number'
        ? `ชวนเพื่อนมาเช็คเลข ${keyword} ด้วยกัน!`
        : `เพื่อนเธอฝันอะไร? ชวนมาเช็ค "${keyword}" ด้วยกัน`
      : 'ชวนเพื่อนมาหาเลขเด็ดจากฝัน — ฟรี!';

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: 'Hotto', text, url });
        recordShare('native');
        return;
      } catch {
        /* cancelled */
      }
    }
    handleCopy();
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`${text}\n${url}`);
      recordShare('copy');
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      setCopied(false);
    }
  };

  const handleSocialClick = (channel) => {
    recordShare(channel);
  };

  return (
    <aside className={`viral-share viral-share--${variant}`} aria-label="แชร์ให้เพื่อน">
      <div className="viral-share__header">
        <span className="viral-share__emoji" aria-hidden="true">📣</span>
        <div>
          <p className="viral-share__hook">{hook}</p>
          <p className="viral-share__sub">แชร์ลิงก์ — เพื่อนกดแล้วเห็นผลเดียวกันทันที</p>
        </div>
      </div>

      <div className="viral-share__actions">
        <button type="button" className="viral-share__btn viral-share__btn--primary" onClick={handleNativeShare}>
          {copied ? 'คัดลอกแล้ว ✓' : 'แชร์เลย'}
        </button>
        <a
          href={lineUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="viral-share__btn viral-share__btn--line"
          onClick={() => handleSocialClick('line')}
        >
          LINE
        </a>
        <a
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="viral-share__btn viral-share__btn--facebook"
          onClick={() => handleSocialClick('facebook')}
        >
          Facebook
        </a>
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="viral-share__btn viral-share__btn--whatsapp"
          onClick={() => handleSocialClick('whatsapp')}
        >
          WhatsApp
        </a>
      </div>

      {shareStats.total > 0 && (
        <p className="viral-share__stats">คุณแชร์ไปแล้ว {shareStats.total} ครั้ง — ขอบคุณที่ชวนเพื่อน! 🙏</p>
      )}
    </aside>
  );
}
